import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isEmpty } from 'lodash'

import { centsToDollars } from '../utils/formatters'
import Button from './Button'
import NumberPad from  './NumberPad'
import { ReactComponent as CloseIcon } from '../assets/icons/sidebar-modal-close.svg'
import useNumberPad from  '../hooks/useNumberPad'
import styles from './Keypad.module.scss'

const secureFormatter = (value) => {
  return value.replace(/./g, '•')
}

const Keypad = ({ secret, maxLength, adjustedItemPriceIndex, item, onConfirm, onClose, title,
    interactionType, className }) => {
  const resolveInitialValue = () => {
    if (adjustedItemPriceIndex.items[item?.id]) {
      return adjustedItemPriceIndex.items[item?.id]
    } else if (!isEmpty(item)) {
      return item?.priceInCents
    } else {
      return ''
    }
  }

  const classNames = cn(styles.quantityEntryModal, className)
  const formatter = secret ? secureFormatter : centsToDollars
  const [overwriteValue, setOverwriteValue] = useState(true)
  const titleAddOn = item?.name ?? ''

  const [
    output,
    onInput,
    rawValue,
  ] = useNumberPad(
    resolveInitialValue(),
    formatter,
    (value) => parseInt(value) > 0,
    maxLength,
    secret ? '' : '0'
  )

  const onTapNumberPad = (value) => {
    onInput(value, overwriteValue)
    if (overwriteValue) setOverwriteValue(false)
  }

  let cancelButton = <Button className={styles.cancelButton} onClick={onClose}>Cancel</Button>
  if (document?.body?.clientWidth <= 800) {
    cancelButton = <CloseIcon className={styles.closeIcon} onClick={onClose} />
  }

  const numPadElement = interactionType === 'press' ? <NumberPad onPressButton={onTapNumberPad} /> : <NumberPad onTapButton={onTapNumberPad} />

  return (
    <div className={classNames}>
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <div className={styles.body}>
          <div className={styles.title}><div className={styles.titleMessage}>{`${title}${titleAddOn}`}</div></div>
          <div className={styles.numberPadGrid}>
            <div className={styles.displayQuantity}>{output}</div>
            {numPadElement}
          </div>
          <div className={styles.rightSidebar}>
            <Button className={styles.confirmSetQuantity} onClick={()=> onConfirm(rawValue, item)}>Confirm</Button>
            {cancelButton}
          </div>
        </div>
      </div>
    </div>
  )
}

Keypad.defaultProps = {
  adjustedItemPriceIndex: { items: {}, totalQuantity: 0 },
  item: {},
  decimal: false,
  maxLength: 6,
  title: '',
  className: '',
  onConfirm: () => {},
  onClose: () => {},
}

Keypad.propTypes = {
  adjustedItemPriceIndex: PropTypes.shape({
    items: PropTypes.object,
    totalQuantity: PropTypes.number,
  }),
  title: PropTypes.string,
  className: PropTypes.string,
  decimal: PropTypes.bool,
  maxLength: PropTypes.number,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
}

export default Keypad